import React from "react";
import Router from "./router";
import { RouterProvider } from "react-router";
import "./App.css";

const App = () => {
  return <RouterProvider router={Router} />;
};

export default App;
